<app-menu-bar></app-menu-bar>

<div class="admin-page">
    <div class="admin-container">
        <app-admin-nav></app-admin-nav>

        <div class="toolbar">
            <div class="search">
                <i class="fa-light fa-magnifying-glass" aria-hidden="true"></i>
                <input type="text" [(ngModel)]="search" [placeholder]="'users_search_placeholder' | translate" autocomplete="off" />
            </div>
            <button class="add-btn" type="button" (click)="openUserModal()">{{ 'users_add' | translate }}</button>
        </div>

        @if (loading) {
            <p class="state-text">{{ 'admin_loading' | translate }}</p>
        } @else if (users.length === 0) {
            <p class="state-text">{{ 'users_empty' | translate }}</p>
        } @else if (filteredUsers.length === 0) {
            <p class="state-text">{{ 'users_no_match' | translate }}</p>
        } @else {
            <div class="table-wrap">
                <table class="admin-table">
                    <thead>
                        <tr>
                            <th>{{ 'field_username' | translate }}</th>
                            <th>{{ 'field_name' | translate }}</th>
                            <th>{{ 'field_mobile' | translate }}</th>
                            <th>{{ 'field_email' | translate }}</th>
                            <th>{{ 'field_category' | translate }}</th>
                            <th class="center">{{ 'field_active' | translate }}</th>
                            <th class="actions-col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (u of filteredUsers; track u.id) {
                            <tr>
                                <td>{{ u.username }}</td>
                                <td>{{ u.name }}</td>
                                <td>{{ u.mobile }}</td>
                                <td>{{ u.email }}</td>
                                <td class="categories">
                                    @if ((u.categoryNames || []).length) {
                                        <span class="chips">
                                            @for (c of u.categoryNames; track c) {
                                                <span class="chip">{{ c }}</span>
                                            }
                                        </span>
                                    } @else {
                                        <span class="muted">—</span>
                                    }
                                </td>
                                <td class="center">
                                    @if (u.active) {
                                        <span class="active-badge" [ngbTooltip]="'field_active' | translate" container="body">
                                            <fa-icon [icon]="faCheck"></fa-icon>
                                        </span>
                                    } @else {
                                        <span class="inactive-dot" [ngbTooltip]="'users_status_inactive' | translate" container="body"></span>
                                    }
                                </td>
                                <td class="actions-col">
                                    <button type="button" class="icon-btn" (click)="openUserModal(u)"
                                        [ngbTooltip]="'admin_action_edit' | translate" container="body">
                                        <fa-icon [icon]="faPen"></fa-icon>
                                    </button>
                                    <button type="button" class="icon-btn danger" (click)="remove(u)"
                                        [ngbTooltip]="'admin_action_delete' | translate" container="body">
                                        <fa-icon [icon]="faTrash"></fa-icon>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>

<app-footer></app-footer>
